import { Component, OnInit } from '@angular/core';
import { HotToastService } from '@ngneat/hot-toast';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

import { AccountService } from 'src/app/core/services/account.service';
import { RegistrationService } from 'src/app/core/services/registration.service';
import { TestTypeEnum } from 'src/app/core/dtos/enum';
import { BooleanLiteral } from 'typescript';

import { FormGroup, FormsModule, FormBuilder, Validators } from '@angular/forms';
import { EssaySubmissionRequest } from 'src/app/core/dtos/dto';

@Component({
  selector: 'app-apply-scholarship',
  templateUrl: './apply-scholarship.component.html',
  styleUrls: ['./apply-scholarship.component.scss']
})
export class ApplyScholarshipComponent implements OnInit {

  essayFile: File;
  scholarshipAgreement: boolean;
  files: FileList;
  fileTypeInvalid: boolean;
  fileSizeInvalid: boolean;
  currentDate: Date;
  programTypeList = ["Undergraduate degree", "Undergraduate diploma", "Graduate/Postgraduate degree", "Graduate/Postgraduate diploma"]
  isOtherProgramSelected: boolean;
  userForm: FormGroup;
  programType: string;
  scholarshipURL = "https://www.cael.ca/scholarships";
  scholarshipTermsURL = "https://www.paragontesting.ca/paragon-testing-scholarships-terms-conditions/";

  constructor(
    private accountService: AccountService,
    private toastService: HotToastService,
    private router: Router,
    private formBuilder: FormBuilder
  ) {
    this.fileTypeInvalid = true;
    this.fileSizeInvalid = true;
  }

  ngOnInit(): void {
    this.currentDate = new Date();
    this.checkEligibility();
    this.isOtherProgramSelected = false;
    this.scholarshipAgreement = false;
    this.userForm = this.formBuilder.group({
      institutionName: ['', [Validators.required]], programType: ['', [Validators.required]]
    });
  }

  checkEligibility() {
    this.accountService.checkEligibility()
      .subscribe(
        result => {
          if (!result.content) {
            this.toastService.show("Permissison Denied! You are not eligible for scholarship. You should have score of 60 or above on CAEL CE Test to be eligible");
            setTimeout(() => {
              this.router.navigate(['my-account']);
            }, 1500);
          }
        },
        (error: HttpErrorResponse) => {
          if (error.status !== 401) {
            this.toastService.warning("Failed to load page. Please contact Paragon.");
          }
        });
  }

  fileChangeEvent(e: Event) {
    const target = e.target as HTMLInputElement;
    this.files = target.files as FileList;

    if (this.files[0]) {
      const fileSize = this.files[0].size / 1024 / 1024;

      if (fileSize > 5) {
        this.fileSizeInvalid = false;
      } else {
        this.fileSizeInvalid = true;
      }

      if (this.files[0].type !== 'application/pdf') {
        this.fileTypeInvalid = false;
      } else {
        this.fileTypeInvalid = true;
      }
    }
  }



  onSubmit() {
    const essaySubmission: EssaySubmissionRequest = {
      institutionName: this.userForm.controls.institutionName.value,
      programType: this.userForm.controls.programType.value
    };
    const formData: FormData = new FormData();
    formData.append("file", this.files[0]);
    this.accountService.submitEssay(formData, essaySubmission)
      .subscribe(() => {
        this.toastService.success("Scholarship Application Submitted Successfully");
        this.router.navigate(['my-account']);
      },
        (error: HttpErrorResponse) => {
          if (error.status !== 401) {
            this.toastService.warning("Failed to upload essay. Please contact Paragon");
          }
        });
  }

}
